// app/middleware/notFoundFrance.ts

export default defineNuxtRouteMiddleware((from, to) => {
  if (to.params.region === "france") {
    throw createError({ statusCode: 404 });
  }
});
